import { Colors, Icon, Typography, type IconName } from '@amelio/ui-library';

import type { ReactNode } from 'react';

/** The answer is rendered above the survey's single notice, by a page that does not hold it. */
export const CONFIDENTIALITY_NOTICE_ID = 'survey-confidentiality-notice';

export type ConfidentialityNoticeProps = {
    message: string;
    iconName: IconName;
    /** Lets the field the notice is about name its message as its description. */
    id?: string;
    /** Follows the message on its line: a way to read more. */
    details?: ReactNode;
};

export const ConfidentialityNotice = ({
    message,
    iconName,
    id,
    details,
}: ConfidentialityNoticeProps) => (
    <div className={'mt-2 flex items-center gap-2'}>
        <Icon
            name={iconName}
            color={Colors.WHITE}
            size={'sm'}
            className={'shrink-0'}
        />

        <div className={'flex flex-wrap items-center gap-x-1'}>
            <Typography
                id={id}
                variant={'body-small'}
                color={Colors.WHITE}
                weight={'light'}
                className={'text-responsive-xs-sm'}
            >
                {message}
            </Typography>

            {details}
        </div>
    </div>
);
